import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { BREAKPOINT } from '../../constants'

export const ModalConteudoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
`

export const ModalWrapper = styled.div`
  .background--modal {
    pointer-events: none;
  }
  section {
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      height: 100%;
    }
  }
`

export const Titulo = styled.h3`
  ${StyleGuide.tipografia.titulo3};
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.boldFonte};
  margin: 12px 0;
`

export const Descricao = styled.p`
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.tipografia.textoPequeno};
  margin-bottom: 5px;

  &:last-of-type {
    margin-bottom: 5px;
  }

  .destque {
    ${StyleGuide.boldFonte};
  }
`

export const WrapperButton = styled.div`
  margin: auto;
  margin-top: 10px;
  width: 100%;

  .baixar-pix:active,
  .baixar-pix,
  .baixar-pix:visited {
    color: inherit;
    height: 100%;
    width: 100%;
  }

  button {
    width: 100%;
  }

  @media (max-width: ${BREAKPOINT.md}) {
    button {
      margin-bottom: 0px;
    }
  }
`

export const LoaderPix = styled.div`
  align-items: center;
  background: rgba(255, 255, 255, .8);
  display: flex;
  height: calc(100% - 40px);
  justify-content: center;
  left: 20px;
  position: absolute;
  top: 20px;
  width: calc(100% - 40px);
  z-index: 9999;
`
